import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import useTheme from "@material-ui/core/styles/useTheme";

import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import { Link } from "@material-ui/core";

const ProfileLicensingDialog = ({ close, open }) => {
	const classes = useStyles("Profile");

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

	return (
		<Dialog
			scroll="paper"
			fullScreen={fullScreen}
			fullWidth={true}
			maxWidth={"sm"}
			open={open}
			onClose={close}
			aria-labelledby="editorial integrity"
			aria-describedby="editorial integrity"
		>
			<DialogTitle disableTypography style={{ minHeight: 50 }}>
				<Box position={"absolute"} top={6} right={6}>
					<IconButton aria-label="close" onClick={close}>
						<CloseIcon />
					</IconButton>
				</Box>
			</DialogTitle>
			<DialogContent>
				<Box mb={12} mx={8}>
					<Box display="flex" alignItems="center" pb={8}>
						<Box fontWeight={700} lineHeight={1.4} fontSize={22}>
							License and credential details
						</Box>
					</Box>

					<Grid container spacing={8}>
						<Grid item xs={12}>
							<Paper variant="outlined" className={classes.licensePaper}>
								<div className={classes.licenseHead}>
									<VerifiedUserIcon
										fontSize="small"
										className={classes.licenseIcon}
									/>
									<div className={classes.licenseTitle}>License</div>
								</div>
								{/* wrap in if... */}
								<div className={classes.licenseFact}>
									<span>Holder:</span>Triston Wilson
								</div>
								<div className={classes.licenseFact}>
									<span>Type:</span> Air Conditioning / Refrigeration Contractor
									(TX)
								</div>
								{/* wrap in if... */}
								<div className={classes.licenseFact}>
									<span>Number:</span> #TACLA00078853E
								</div>
								{/* wrap in if... */}
								<div className={classes.licenseFact}>
									<span>Issued:</span> 8/17/2022
								</div>
								{/* wrap in if... */}
								<div className={classes.licenseFact}>
									<span>Valid through:</span> 8/17/2025
								</div>
								{/* wrap in if... */}
								<div className={classes.licenseFact}>
									<span>Verified:</span> 5/17/2023
								</div>
								{/* if capacity... */}
								<div className={classes.licenseFact}>
									<span>Capacity:</span> 198
								</div>
								<div className={classes.licenseFact}>
									<Link
										color="primary"
										target="_blank"
										href="http://www.dfps.state.tx.us/Child_Care/Search_Texas_Child_Care/default.asp"
									>
										<span>Verify license</span>
									</Link>
								</div>
							</Paper>
						</Grid>
					</Grid>
				</Box>
			</DialogContent>
		</Dialog>
	);
};

ProfileLicensingDialog.propTypes = {};
export default ProfileLicensingDialog;
